import { createSlice, createAction } from '@reduxjs/toolkit'
import { handleErrorStopLoading, handleFail, handleLoading, handleStopLoading } from 'redux/redux-util';

const initialState = {
  loading: false,
  accepted: false,
  investorPropertiesValid: false,
  disclaimers: {},
  disclaimerAlertCode: undefined,
};

const slice = createSlice({
  initialState,
  name: 'disclaimer',
  reducers: {
    acceptDisclaimer: () => { },
    acceptDisclaimerSuccess: () => { },
    acceptDisclaimerFailure: () => { },

    acceptPDPA: () => { },
    acceptPDPASuccess: handleStopLoading,
    acceptPDPAFailure: handleFail,

    accept: handleLoading,
    acceptSuccess: state => {
      state.loading = false;
      state.accepted = true;
    },
    acceptFailure: state => {
      state.loading = false;
      state.accepted = false;
    },

    notAccept: state => {
      state.accepted = false;
    },
    validInvestorProperties: state => {
      state.investorPropertiesValid = true;
    },
    oauthBypassAcceptedDisclaimerProcess: state => {
      state.accepted = true;
      state.investorPropertiesValid = true;
    },

    getDisclaimerList: handleLoading,
    getDisclaimerListSuccess: (state, action) => {
      state.loading = false;
      state.disclaimers = action.payload;
    },
    getDisclaimerListFailure: handleErrorStopLoading,
  }
})

export const getDisclaimerList
  = createAction('disclaimer/getDisclaimerList', payload => payload ? { payload } : { payload: {} });
export const redirectToPrimaryProduct
  = createAction('disclaimer/redirectToPrimaryProduct')
export const redirectToSecondaryProduct
  = createAction('disclaimer/redirectToSecondaryProduct')
  export const redirectToRiskResult
  = createAction('disclaimer/redirectToRiskResult')
export const redirectToBuySellSwitch
  = createAction('disclaimer/redirectToBuySellSwitch')
export const redirectToModelPortfolio
  = createAction('disclaimer/redirectToModelPortfolio')

export const {
  validInvestorProperties,
  acceptDisclaimer, acceptDisclaimerSuccess, acceptDisclaimerFailure,
  acceptPDPA, acceptPDPASuccess, acceptPDPAFailure,
  accept, acceptSuccess, acceptFailure, notAccept,
  getDisclaimerListSuccess, getDisclaimerListFailure,
  oauthBypassAcceptedDisclaimerProcess,
} = slice.actions;

export default slice.reducer;